import React, { useContext, useMemo, useState } from "react";
import PropTypes from "prop-types";
import Chat from "../common/Chat";
import Sessions from "../common/Chat/Sessions";
import SideBar from "../common/Chat/SideBar";
import ChatSessionContext from "../../contexts/ChatSessionContext";

const Full = ({ userId }) => {
  const { currentSession, setCurrentSession } = useContext(ChatSessionContext);

  const handleSelectSession = (id) => {
    setCurrentSession(id);
  };

  return (
    <div className="full-chats">
      <div className="full-chats-sessions">
        <Sessions
          userId={userId}
          onSelectSession={handleSelectSession}
          mini={false}
        />
      </div>
      <div className="full-chats-content">
        {currentSession && (
          <Chat sessionId={currentSession} userId={userId} mini={false} />
        )}
      </div>
      {/* {currentSession && <SideBar />} */}
    </div>
  );
};

Full.propTypes = {};

export default Full;
